/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { request } from '@/services/request';

import { useAuth } from '@/hooks/useAuth';

export const useTenantId = () => {
  const { auth } = useAuth();
  const pathname = usePathname();

  const [tenantId, setTenantId] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (pathname.includes('/en/apps')) return;
    const fetchTenantId = async () => {
      if (!auth?.accessToken) return;
      setLoading(true);
      try {
        const response = await request.get({ endpoint: 'tenant' });
        if (response[0]?.tenant_id) {
          setTenantId(response[0].tenant_id);
          // Store tenant ID for global access
          localStorage.setItem('currentTenantId', response[0].tenant_id);
        }
      } catch (error) {
        console.error('Error fetching tenant ID:', error);
        setError('Failed to fetch tenant ID.');
      } finally {
        setLoading(false);
      }
    };

    fetchTenantId();
  }, [auth?.accessToken]);

  return { tenantId, loading, error };
};
